import styled from 'styled-components'
import { boxShadowHover, slideUpReveal } from '../../ui/theme/animations'
import colors from '@rodeo-dev/legos/dist/themes/colors'

const CardContainer = styled.span`
  ${slideUpReveal}
  ${boxShadowHover}

  background-color: #ffffff;
  border: 1px solid ${colors.elements.border};
  cursor: pointer;
  display: inline-block;
  height: 100%;
  text-align: center;
  width: 100%;
`

export { CardContainer }
